
    import {Component, Prop, Vue} from 'vue-property-decorator';
    import {Question} from '@/lib/Question';
    @Component({})
    export default class TextareaQuestion extends Vue {
        @Prop() public question: Question;

        mounted(){
            // console.log('texarea '+this.question.label);
        }
    }
